var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "loading-docs-ia-dialog-container" },
    [
      _c("p", { staticClass: "loading-docs-ia-text" }, [
        _vm._v(
          _vm._s(_setup.t("components.file_manager.dialogs.docs_IA_message"))
        ),
      ]),
      _c(_setup.SpinnerLayerComponent),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }